import type {HistoryItem} from '@AiChat/ai-chat.types';

export interface ChatHistoryListItemOptionsProps {
  historyItem: HistoryItem;
  onStartRename: VoidFunction;
  onOpen: VoidFunction;
  onClose: VoidFunction;
  onDelete: VoidFunction;
}

export const CHAT_HISTORY_LIST_ITEM_OPTIONS_PANEL_ID = 'ChatHistoryListItemOptionsPanelId';
